const emptyLeaf = {
  empty: { id: 'empty', data: { title: '<Empty>' } },
};

const createBranch = (name = 'branch', expanded = true, depth) => {
  return {
    id: name,
    data: {
      title: name,
    },
    depth,
    children: [],
    hasChildren: true,
    isExpanded: expanded,
  };
};

const convertToTreeData = (data = []) => {
  const treeData = { rootId: 'root', items: { root: createBranch('root', 0), ...emptyLeaf } };

  if (!Array.isArray(data)) {
    return treeData;
  }

  const traverse = (tree, depth = 0, parent = 'root') => {
    for (const branch of tree) {
      if (!branch) {
        continue;
      }

      if (branch.items) {
        // Add To Parent
        treeData.items[parent].children.push(branch.name);

        // Create Branch
        treeData.items[branch.name] = createBranch(branch.name, branch.x, depth);
        traverse(branch.items, depth + 1, branch.name);
      } else {
        if (tree.length !== 1 && branch === 'empty') { continue; }
        const id = branch === 'empty' ? `empty-${parent}` : branch;
        // Add To Parent
        treeData.items[parent].children.push(id);

        // Create Leaf
        treeData.items[id] = {
          id,
          data: {
            title: branch,
          },
          depth,
          children: [],
        };
      }
    }
  };

  traverse([...data]);
  return treeData;
};

const convertToSimple = tree => {
  const { rootId, items } = tree;

  const data = [];

  const traverse = (id, parent) => {
    if (/^empty/.test(id)) {
      parent.push('empty');
      return;
    }

    if (items[id].children.length) {
      const newParent = { name: items[id].data.title, items: [], x: items[id].isExpanded };
      parent.push(newParent);
      for (const child of items[id].children) {
        traverse(child, newParent.items);
      }
    } else {
      parent.push(items[id].data.title);
    }
  };

  traverse(rootId, data);

  return data[0].items ? data[0].items : [];
};

const removeFromSimple = (data = [], item = '') => {
  const traverse = (tree, parent = 'root') => {
    let index = 0;
    for (const branch of tree) {
      if (branch.items) {
        if (branch.name === item) {
          tree.splice(index, 1);
        } else {
          traverse(branch.items, branch.name);
        }
      } else {
        if (item === branch) {
          tree.splice(index, 1);

          if (parent !== 'root' && tree.length === 0) {
            tree.push('empty');
          }
        }
      }
      index++;
    }
  };

  traverse(data);
  return data;
};

const renameFromSimple = (data = [], oldName = '', newName = '') => {
  const traverse = tree => {
    for (const branch of tree) {
      if (branch.items) {
        if (branch.name === oldName) {
          branch.name = newName;
        } else {
          traverse(branch.items);
        }
      }
    }
  };

  traverse(data);
  return data;
};

const isFavorite = (data = [], item = '') => {
  let found = false;
  const traverse = tree => {
    for (const branch of tree) {
      if (!branch) {
        continue;
      }

      if (branch.items) {
        traverse(branch.items);
      } else {
        if (item === branch) {
          found = true;
          return;
        }
      }
    }
  };

  traverse(data);
  return found;
};

const hasFolder = (data = [], folder = '') => {
  let found = false;
  const traverse = tree => {
    for (const branch of tree) {
      if (branch.items) {
        if (branch.name === folder) {
          found = true;
          return;
        }
        traverse(branch.items);
      }
    }
  };

  traverse(data);
  return found;
};

export { convertToTreeData, convertToSimple, removeFromSimple, isFavorite, renameFromSimple, hasFolder };
